import {
	QueryParamConfig,
	UrlUpdateType,
	decodeDelimitedArray,
	encodeDelimitedArray,
	useQueryParam
} from 'use-query-params';
import { CheckboxItem } from 'components/core/checkbox-group';
import { useAppSelector } from 'redux/store';

export const THEME_QUERY_KEY = 'thema';

type NewValueType<D> = D | ((latestValue: D) => D);

export type UseThemeReturn = {
	selectedThemes: CheckboxItem[];
	selectedThemesParam: string | (string | null)[] | null | undefined;
	setSelectedThemesParam: (
		newValue: NewValueType<CheckboxItem[] | null | undefined>,
		updateType?: UrlUpdateType | undefined
	) => void;
};

export const useTheme = (): UseThemeReturn => {
	const { themes } = useAppSelector((state) => state.themes);

	const [selectedThemesParam, setSelectedThemesParam] = useQueryParam(THEME_QUERY_KEY, ThemeArrayParam);
	const selectedThemes = themes.filter((theme) => selectedThemesParam?.includes(String(theme.documentId)));

	return {
		selectedThemes: selectedThemes.map((theme) => ({
			id: theme.documentId,
			label: theme.attributes?.title || ''
		})),
		selectedThemesParam,
		setSelectedThemesParam
	};
};

export const ThemeArrayParam: QueryParamConfig<
	CheckboxItem[] | null | undefined,
	string | (string | null)[] | null | undefined
> = {
	encode: (array) => {
		if (array == null) {
			return undefined;
		}

		const themes = array.filter(Boolean).map((checkboxItem) => String(checkboxItem.id));
		const value = themes.length > 0 ? themes : null;
		return encodeDelimitedArray(value);
	},
	decode: (param) => {
		return decodeDelimitedArray(param);
	}
};
